module.exports = __webpack_public_path__ + "static/assets/f162874eb46ed9fb263cf97ea27e18b9.svg";